import styled from "styled-components";
import breakpoints from "../../constants/breakpoints";
export const Styles = styled.div`
  color: #000 !important;
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? backgroundColor : "var(--main-red)"};
  .main-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 2rem;
    p {
      color: var(--white);
      font-size: 1.2rem;
      font-weight: 500;
    }
    .logo-container {
      width: 250px;
      height: 140px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
  .copyright-section {
    padding: 20px 0;
    text-align: center;
    border-top: 1px solid #e8eff8;
    p {
      margin: 0 !important;
    }
    span {
      font-size: 17px;
    }
  }
  @media (max-width: 1280px) {
    .row-container {
      .logo-col {
        .undp-log {
          img {
            width: 92px;
            height: 180px;
            object-fit: contain;
          }
        }
      }
    }
  }
  @media (max-width: 1024px) {
  }
  @media (max-width: ${breakpoints.md}) {
  }
  @media (max-width: ${breakpoints.sm}) {
    .main-container {
      padding-top: 1rem;
      padding-bottom: 1rem;
      flex-direction: column;
      gap: 1rem;
    }
  }
`;
